import { IOriginAddressMeter } from '../fetchers';
import { SalesStructuredAddress } from '../models';

export interface IOriginAddressInternet {
  addressLabel?: string;
  addressId: string;
  structuredAddress: SalesStructuredAddress;
}

export const AddressTypes = {
  NMI: 'NMI',
  MIRN: 'MIRN',
  LOC_OPC: 'LOC_OPC',
} as const;

export type AddressType = keyof typeof AddressTypes;

export type AddressManualEntryField =
  | 'unitType'
  | 'unitNumber'
  | 'allotment'
  | 'streetNumber'
  | 'streetName'
  | 'streetType'
  | 'streetTypeSuffix'
  | 'city'
  | 'state'
  | 'postcode';
export type AddressManualEntryValues = Record<AddressManualEntryField, string | undefined>;

export interface InternalSearchTabMeta {
  label: string;
  component: React.ComponentType<{
    endpoint: string;
    onConfirm: (address: IOriginAddressMeter | IOriginAddressInternet) => void;
  }>;
}

export interface AddressSearchTabConfig {
  type: AddressType;
  endpoint: string;
  onConfirm: ((address: IOriginAddressMeter | null) => void) &
    ((address: IOriginAddressInternet | null) => void);
}
